(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-videos"] && !Shopify.designMode) return;
  try {
    function initVideoPrimeToggles(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-video-prime-toggle]').forEach(function (btn) {
      if (btn.dataset.videoPrimeReady) return;
      btn.dataset.videoPrimeReady = 'true';

      const wrapper = btn.closest('[data-video-prime]');
      const video = wrapper && wrapper.querySelector('video');
      if (!video) return;

      const pauseIcon = btn.querySelector('[data-video-prime-pause]');
      const playIcon = btn.querySelector('[data-video-prime-play]');
      let priming = false;
      let primed = false;
      let userPlaying = false;

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.preload = 'auto';
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', 'true');
      video.setAttribute('x5-playsinline', 'true');
      if ('disablePictureInPicture' in video) video.disablePictureInPicture = true;

      const afterPaintedFrames = function (callback) {
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(function () {
            video.requestVideoFrameCallback(callback);
          });
        } else {
          requestAnimationFrame(function () {
            requestAnimationFrame(callback);
          });
        }
      };

      const finishPrime = function () {
        if (userPlaying) {
          primed = true;
          return;
        }
        video.pause();
        video.removeAttribute('poster');
        primed = true;
        priming = false;
      };

      const primeVideo = function () {
        if (priming || primed || userPlaying) return;
        priming = true;
        const scrollY = window.scrollY;
        const playPromise = video.play();
        if (!playPromise || typeof playPromise.then !== 'function') {
          finishPrime();
          return;
        }
        playPromise
          .then(function () {
            if (Math.abs(window.scrollY - scrollY) > 1) {
              window.scrollTo(0, scrollY);
            }
            afterPaintedFrames(finishPrime);
          })
          .catch(function () {
            priming = false;
          });
      };

      const setPlaying = function (playing) {
        btn.classList.toggle('is-playing', playing);
        btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        if (pauseIcon) pauseIcon.hidden = !playing;
        if (playIcon) playIcon.hidden = playing;
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                primeVideo();
                observer.disconnect();
              }
            });
          },
          { rootMargin: '200px' }
        );
        observer.observe(wrapper);
      } else {
        primeVideo();
      }

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (video.paused) {
          const group = btn.closest('[data-product-videos-block]');
          if (group) {
            group.querySelectorAll('[data-video-prime-toggle]').forEach(function (otherBtn) {
              if (otherBtn === btn) return;
              let otherVideo = otherBtn.closest('[data-video-prime]');
              otherVideo = otherVideo && otherVideo.querySelector('video');
              if (!otherVideo || otherVideo.paused) return;
              otherVideo.pause();
              otherVideo.currentTime = 0;
              otherBtn.classList.remove('is-playing');
              otherBtn.setAttribute('aria-label', 'Play video');
              const otherPause = otherBtn.querySelector('[data-video-prime-pause]');
              const otherPlay = otherBtn.querySelector('[data-video-prime-play]');
              if (otherPause) otherPause.hidden = true;
              if (otherPlay) otherPlay.hidden = false;
            });
          }

          userPlaying = true;
          if (wrapper.hasAttribute('data-video-prime-sound')) {
            video.muted = false;
          }
          const scrollY = window.scrollY;
          const playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(function () {
                if (Math.abs(window.scrollY - scrollY) > 1) {
                  window.scrollTo(0, scrollY);
                }
                video.removeAttribute('poster');
              })
              .catch(function () {});
          }
          setPlaying(true);
        } else {
          userPlaying = false;
          video.pause();
          setPlaying(false);
        }
      });
    });
  }

  initVideoPrimeToggles(document);

  document.addEventListener('shopify:section:load', function (event) {
    initVideoPrimeToggles(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
